import { defineEvent } from '../types/event';
export var COUPON_FAB_CLOSE = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
